import ArticleVariantModelBase from '../_generated/modelBases/article-variant-model-base';

export default class ArticleVariantModel extends ArticleVariantModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
